import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Divider, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';

import { withRouter } from "common/utils/router.util";
const styles = theme => ({
  root: {
    padding: theme.spacing(4),
  },
  company: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0.5),
  },
});

class Footer extends Component {
  render() {
    const { classes, className } = this.props;

    const rootClassName = classNames(classes.root, className);

    return (
      <div className={rootClassName}>
        <Divider />
        <Typography className={classes.company} variant="body1">
          &copy; ListGen Inc. {new Date().getFullYear()}
        </Typography>
        <Typography variant="caption">
          Committed to Continuous Innovation
        </Typography>
      </div>
    );
  }
}

Footer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);
